/**
 * Central API timeout values (ms). Override per environment via VITE_* env vars.
 */
export const API_TIMEOUT_MS = Number(import.meta.env.VITE_API_TIMEOUT_MS) || 120_000

/** Rollback, large exports, approvals sync — may run many minutes. */
export const API_LONG_RUNNING_TIMEOUT_MS =
  Number(import.meta.env.VITE_API_LONG_RUNNING_TIMEOUT_MS) || 3_600_000

/** SAP / CPI document fetch under bulk load. */
export const API_SAP_TIMEOUT_MS = Number(import.meta.env.VITE_API_SAP_TIMEOUT_MS) || 180_000

/** Multipart upload to S3 via POD API. */
export const API_FILE_UPLOAD_TIMEOUT_MS =
  Number(import.meta.env.VITE_API_FILE_UPLOAD_TIMEOUT_MS) || 300_000

/** Large metadata payloads (store-files, check-existing). */
export const API_BULK_METADATA_TIMEOUT_MS =
  Number(import.meta.env.VITE_API_BULK_METADATA_TIMEOUT_MS) || 600_000
